import ConstituentSearchFilterField from '@/constants/ConstituentSearchFilterField';

// This is the order the fields are displayed in the criteria select
const AdvancedFilterCriteria = [
  ConstituentSearchFilterField.NAME_EMAIL_PHONE,
  ConstituentSearchFilterField.USER_IDS,
  ConstituentSearchFilterField.CONSTITUENT_CATEGORIES,
  ConstituentSearchFilterField.CITY,
  ConstituentSearchFilterField.STATE,
  ConstituentSearchFilterField.POSTAL_CODE,
  ConstituentSearchFilterField.COUNTRY,
  ConstituentSearchFilterField.CONSTITUENT_LABEL_IDS,
  ConstituentSearchFilterField.BIRTHDAY_MONTH,
  ConstituentSearchFilterField.DOB,
  ConstituentSearchFilterField.BOARD_IDS,
  ConstituentSearchFilterField.COLUMN_IDS,
  ConstituentSearchFilterField.CONNECTION_EMPLOYER_CONSTITUENT_IDS,
  ConstituentSearchFilterField.CONNECTION_HOUSEHOLD_CONSTITUENT_IDS,
  ConstituentSearchFilterField.CONNECTION_CONSTITUENT_IDS,
  ConstituentSearchFilterField.IS_DECEASED,
  ConstituentSearchFilterField.DONATION_TYPES,
  ConstituentSearchFilterField.CAMPAIGN_IDS,
  ConstituentSearchFilterField.DONATION_THIS_YEAR_TOTAL_AMOUNT,
  ConstituentSearchFilterField.DONATION_LAST_YEAR_TOTAL_AMOUNT,
  ConstituentSearchFilterField.DONATION_LIFETIME_TOTAL_AMOUNT,
  ConstituentSearchFilterField.DONATION_AMOUNT,
  ConstituentSearchFilterField.DONATION_THIS_YEAR_TOTAL_TIME,
  ConstituentSearchFilterField.DONATION_LAST_YEAR_TOTAL_TIME,
  ConstituentSearchFilterField.DONATION_LIFETIME_TOTAL_TIME,
  ConstituentSearchFilterField.DONATION_MINUTES,
  ConstituentSearchFilterField.DONATION_MADE,
  ConstituentSearchFilterField.DONATION_DATE,
  ConstituentSearchFilterField.DONATION_PLAN_CADENCE,
  ConstituentSearchFilterField.IN_HONOR,
  ConstituentSearchFilterField.DONATION_LABEL_IDS,
];

export default AdvancedFilterCriteria;
